export default "__VITE_ASSET__CBq$psi5__"